import gql from "graphql-tag";

const barQuery = gql`
  query allBars($page: Int) {
    allBars(page: $page) {
      docs {
        __typename
        ... on Bar {
          _id
          name
          description
          hours {
            day
            open
            close
          }
          address {
            EN
            CH
          }
          imageURLs {
            url
            description
          }
          dailySpecials {
            name
            day
            description
            imageURL
          }
          happyHours {
            day
            startTime
            endTime
            description
            imageURL
          }
          prices {
            name
            beer
            wine
            cocktail
          }
          categories
          featured
          published
        }
      }
      nextPage
      prevPage
      hasPrevPage
      hasNextPage
      page
    }
  }
`;

export default barQuery;
